import script from "./MoveLocationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveLocationModal.vue?vue&type=script&setup=true&lang=js"

import "./MoveLocationModal.vue?vue&type=style&index=0&id=6162c219&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6162c219"]])

export default __exports__